import StatusLegendData from "../../../../common/components/status-legend/types/status-legend-data";
import StatusLegendStatuses from "../../../../common/components/status-legend/types/status-legend-statuses";
import {
  OrderCargoOrderActiveListItem,
  OrderCargoOrderActiveListItemExecutionStatus,
} from "../../../../common/services/order/cargo-order/active-list/order-cargo-order-active-list";
import orderTranslationsHelper from "../../../../languages/order-translations.helper";

const getStatusFromExecutionStatus = (
  executionStatus: OrderCargoOrderActiveListItemExecutionStatus,
): StatusLegendStatuses => {
  switch (executionStatus) {
    case OrderCargoOrderActiveListItemExecutionStatus.CANDIDATURE:
      return StatusLegendStatuses.CANDIDATURE;
    case OrderCargoOrderActiveListItemExecutionStatus.IN_PROGRESS:
      return StatusLegendStatuses.IN_PROGRESS;
    case OrderCargoOrderActiveListItemExecutionStatus.PENDING:
      return StatusLegendStatuses.PENDING;
    case OrderCargoOrderActiveListItemExecutionStatus.PLANNED:
      return StatusLegendStatuses.PLANNED;
  }
};

const getStatusOptions = (
  pageDate: OrderCargoOrderActiveListItem[],
): StatusLegendData[] => {
  const statuses: OrderCargoOrderActiveListItemExecutionStatus[] = [
    OrderCargoOrderActiveListItemExecutionStatus.PENDING,
    OrderCargoOrderActiveListItemExecutionStatus.PLANNED,
    OrderCargoOrderActiveListItemExecutionStatus.IN_PROGRESS,
    OrderCargoOrderActiveListItemExecutionStatus.CANDIDATURE,
  ];

  return statuses.map((executionStatus) => {
    return {
      status: getStatusFromExecutionStatus(executionStatus),
      totalCount: pageDate.filter(
        (item) => item.executionStatus == executionStatus,
      ).length,
    };
  });
};

const getExecutionStatusOptions = () => {
  const translations =
    orderTranslationsHelper.getActiveListingTranslations().executionStatus;

  return [
    {
      label: translations.pendingLabel,
      status: OrderCargoOrderActiveListItemExecutionStatus.PENDING,
    },
    {
      label: translations.plannedLabel,
      status: OrderCargoOrderActiveListItemExecutionStatus.PLANNED,
    },
    {
      label: translations.inProgressLabel,
      status: OrderCargoOrderActiveListItemExecutionStatus.IN_PROGRESS,
    },
    {
      label: translations.candidatureLabel,
      status: OrderCargoOrderActiveListItemExecutionStatus.CANDIDATURE,
    },
  ];
};

const getExecutionStatusLabel = (
  status: OrderCargoOrderActiveListItemExecutionStatus,
): string => {
  const options = getExecutionStatusOptions();

  return options.find((option) => option.status === status)?.label ?? "";
};

const getMobileAppUsingLabel = (isUsing: boolean) => {
  const translations = orderTranslationsHelper.getActiveListingTranslations();

  return isUsing
    ? translations.mobileAppUserTitle
    : translations.noMobileAppUserTitle;
};

const orderActiveListingHelper = {
  getExecutionStatusOptions,
  getExecutionStatusLabel,
  getMobileAppUsingLabel,
  getStatusOptions,
};

export default orderActiveListingHelper;
